import { MedictLinkCaseInfoData } from './medictLink_type';
import { PLATFORM_TYPE } from './type';
import CaseInfo from './caseInfo';
import { PandaCloudCaseInfoData } from './pandaCloud_type';

export default class CaseRespondHandler {
    constructor(platform) {
        const isInclude = [PLATFORM_TYPE.MeditLink, PLATFORM_TYPE.PandaCloud_EN, PLATFORM_TYPE.PandaCloud_EU].includes(
            platform
        );
        this.oauthPlatform = isInclude ? platform : null;
    }

    /**
     * Return proccessed data for case respond
     * @type {(data:[]) => [CaseInfo]}
     */
    handleCaseRespond(caseData) {
        if (!this.oauthPlatform) throw new Error('Platform is not supported');
        if (!caseData || !Array.isArray(caseData)) throw new Error('Invalid case data');
        if (!caseData.length) return [];
        switch (this.oauthPlatform) {
            case PLATFORM_TYPE.MeditLink:
                return this.meditLinkDataHandler(caseData);
            case PLATFORM_TYPE.PandaCloud_EN:
            case PLATFORM_TYPE.PandaCloud_EU:
                return this.pandaCloudDataHandler(caseData);
            default:
                return caseData;
        }
    }

    /**
     * Return proccessed data for case respond
     * @type {(data:[MedictLinkCaseInfoData]) => [CaseInfo]}
     */
    meditLinkDataHandler(caseData) {
        return caseData.map((v) => {
            const { dateCreated, dateScanned, dateUpdated, uuid, name, status, patient, files } = v.caseInfo;
            return new CaseInfo(
                {
                    dateCreated,
                    dateScanned,
                    dateUpdated,
                    uuid,
                    name,
                    status,
                    patient,
                    files,
                },
                this.oauthPlatform
            );
        });
    }

    /**
     * Return proccessed data for case respond
     * @type {(data:[PandaCloudCaseInfoData]) => [CaseInfo]}
     */
    pandaCloudDataHandler(caseData) {
        return caseData.map((v) => {
            const { start, edit, end, id, patient, size } = v.caseInfo;
            return new CaseInfo(
                {
                    dateCreated: start ? start.replace('T ', 'T') : '',
                    dateScanned: end ? end.replace('T ', 'T') : '',
                    dateUpdated: edit ? edit.replace('T ', 'T') : '',
                    uuid: id,
                    name: id,
                    status: '',
                    patient: {
                        name: patient.name,
                    },
                    files: [
                        {
                            name: id,
                            size: size,
                            uuid: id,
                            dateCreated: start ? start.replace('T ', 'T') : '',
                        },
                    ],
                },
                this.oauthPlatform
            );
        });
    }
}
